import { Avatar, Timestamp } from '@dixa/lib-shared-habla';
import type { SearchNoteHit } from 'lib-shared-types-api';
import { PropsWithClassName } from 'lib-shared-types-utils';

import { SearchResult } from '../../../../result/searchResult';

type NoteResultProps = {
  hit: SearchNoteHit;
  onRowClick?: (hit: SearchNoteHit) => void;
} & PropsWithClassName;

/**
 * Represents a component that is used to render a single search result in the
 * notes tab
 */
export const NoteResult = ({
  hit,
  className,
  onRowClick,
}: NoteResultProps): JSX.Element => (
  <SearchResult
    className={className}
    content={{
      title: hit.author?.display_name ?? '',
      message: (
        <span className="search-result-timestamp">
          {'Created '}
          <Timestamp relative time={hit.created_at} />
        </span>
      ),
      avatar: <Avatar user={hit.author} />,
    }}
    onClick={() => onRowClick?.(hit)}
  />
);
